/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { t, translate } from 'react-switch-lang';
import { Link } from 'react-router-dom';
import './contactusform.scss';
import './ContactUsPayments.scss';
import { useSelector } from 'react-redux';
import { SubmitContactUs } from '../../../helperFunctions/SubmitContactUs';
import { mailcheckValidate, validateBody, validateEmail, validateName } from './Validation';
import { setScreenReaderAlert } from '../../../helperFunctions/Accessibility';
import { performSearch } from '../../../components/algolia/AlgoliaUtils';
import RelevantFAQ from './RelevantFAQ';
import ReplaceTextWithElement from '../../../helperFunctions/ReplaceTextWithElement';
import RadioBuilder from './RadioBuilder';

function ContactUsPayments({ widgetMode }) {
  const { brand, lang } = useSelector((state) => state);
  const emailRef = useRef();
  const bodyRef = useRef();
  const nameRef = useRef();
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [disable, setDisable] = useState(false);

  const [validateEmailOnChange, setValidateEmailOnChange] = useState(false);
  const [validateDescriptionOnChange, setValidateDescriptionOnChange] = useState(false);
  const [validatePaymentMethodOnChange, setValidatePaymentMethodOnChange] = useState(false);
  const [validateNameOnChange, setValidateNameOnChange] = useState(false);

  const [paymentMethod, setPaymentMethod] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [suggestedArticleAlertRead, setSuggestedArticleAlertRead] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [showEmailConfirm, setShowEmailConfirm] = useState(false);
  const [runMailCheck, setRunMailCheck] = useState(true);
  const [invalidEmailSuggestion, setInvalidEmailSuggestion] = useState(null);

  const [formError, setFormError] = useState({
    email: null,
    name: null,
    description: null,
    paymentMethod: null,
  });
  const isMobile = (window.location.href.includes('mobileapp') ? '?mobileapp' : '');

  useEffect(() => {
    if (!submitted) return;
    const hasErrors = Object.values(formError).some((err) => err !== null);
    if (hasErrors) {
      const errorField = document.querySelector('.is-invalid');
      if (errorField) {
        const group = errorField.closest('.form-groups');
        if (group) {
          group.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const input = group.querySelector('input, textarea, select');
          input?.focus({ preventScroll: true });
        } else {
          errorField.scrollIntoView({ behavior: 'smooth', block: 'start' });
          errorField.focus({ preventScroll: true });
        }
      }
    }
    setSubmitted(false);
  }, [formError]);

  function sendAPI() {
    const data = {
      Brand: 'PSI Payments',
      BrandID: 'Payments',
      CustomerEmail: emailRef.current.value,
      Body: bodyRef.current.value,
      PaymentOption: paymentMethod,
      Language: lang,
      Name: nameRef.current.value,
    };

    const sending = document.getElementById('submit-button');
    sending.innerHTML = t('ContactForm_Submitting');
    setDisable(true);

    SubmitContactUs(data).then(
      () => {
        setShowError(false);
        document.getElementById('desktop-contact-us').style.visibility = 'hidden';
        document.getElementById('successMessage').style.visibility = 'visible';
        document.getElementById('successMessage').style.display = 'block';
        const focus = document.getElementById('successMessage');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      () => {
        setError(t('Error_Something_Went_Wrong'));
        setShowError(true);
        sending.innerHTML = t('ContactForm_Submit_button');
        setDisable(false);
        const focus = document.getElementById('error_message');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    );
  }

  const handleTextareaChange = (e) => {
    setSearchTerm(e.target.value);
  };

  function validateFormFields(force) {
    const errors = {
      email: null,
      paymentMethod: null,
      description: null,
      name: null,
    };
    if ((validateEmailOnChange || force) && emailRef.current) {
      const { value } = emailRef.current;
      errors.email = validateEmail(value);

      if (errors.email === null) {
        setInvalidEmailSuggestion(mailcheckValidate(value));
        if (runMailCheck && invalidEmailSuggestion !== null) {
          setShowEmailConfirm(true);
          errors.email = t('Contact_EmailSuggestion').replace('xEmail', invalidEmailSuggestion);
        } else {
          setShowEmailConfirm(false);
        }
      } else {
        setShowEmailConfirm(false);
      }
    }
    if ((validateDescriptionOnChange || force) && bodyRef.current) {
      const { value } = bodyRef.current;
      errors.description = validateBody(value);
    }

    if ((validatePaymentMethodOnChange || force) && paymentMethod === '') {
      errors.paymentMethod = t('Validation_Required');
    }

    if ((validateNameOnChange || force) && nameRef.current) {
      const { value } = nameRef.current;
      errors.name = validateName(value);
    }

    setFormError(errors);
    return errors;
  }

  function handleSubmit(e) {
    e.preventDefault();
    setValidateDescriptionOnChange(true);
    setValidateEmailOnChange(true);
    setValidatePaymentMethodOnChange(true);
    setValidateNameOnChange(true);
    setSubmitted(true);

    const errors = validateFormFields(true);
    if (!Object.values(errors).some((err) => err !== null)) {
      sendAPI();
      setScreenReaderAlert(t('ScreenReader_ContactForm_Success'));
    } else {
      setScreenReaderAlert(t('ScreenReader_ContactForm_Error'));
    }
  }

  useEffect(() => {
    if (widgetMode) {
      document.getElementById('desktop-contact-us').style.padding = '0px';
    }
  }, []);

  useEffect(() => {
    async function updateSearchResults() {
      const results = await performSearch(searchTerm, brand, lang);
      if (results.length > 0) {
        setSuggestedArticleAlertRead(true);
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_Suggested_Article', null, lang));
      } else if (suggestedArticleAlertRead) {
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_No_Suggested_Article', null, lang));
      }
      setSearchResults(results);
    }
    const timer = setTimeout(updateSearchResults, 700);
    return () => { clearTimeout(timer); };
  }, [searchTerm, lang]);

  useEffect(() => {
    validateFormFields();
  }, [
    lang,
    validateEmailOnChange,
    validateDescriptionOnChange,
    validatePaymentMethodOnChange,
    validateNameOnChange,
    paymentMethod]);

  return (
    <>
      {showError && (
        <Alert
          variant="danger"
          id="error_message"
          className="mt-3"
          onClose={() => {
            setShowError(false);
            setError('');
          }}
          dismissible
        >
          <p style={{ marginBottom: 0 }}>{error}</p>
        </Alert>
      )}
      <div id="successMessage">
        <h1>{t('ContactForm_Submitted')}</h1>
        <Link to={(widgetMode) ? `/widget/${brand}/${lang}${isMobile}` : `/${brand}/${lang}/categories`}>
          <Button className={`error-go-home-btn ${brand}-button`}>{t('ReturnHome_Btn')}</Button>
        </Link>
      </div>
      <div id="desktop-contact-us">
        <div id="skip-link-content">
          <h1>{t('General_Contact_Us')}</h1>
          <p className="contact-label-suggestion">{t('ContactForm_Fields_Required')}</p>
          <Form noValidate onSubmit={handleSubmit}>

            {/* Email */}
            <Form.Group
              className="form-groups"
              controlId="ContactForm_General_Email_"
              required
            >
              <Form.Label as="legend" id="aria-email" className="form-labels">
                {t('ContactForm_General_Email_Label')}
              </Form.Label>
              <Form.Text className="muted helpText">
                {t('ContactForm_General_Email_Help')}
              </Form.Text>
              <Form.Control
                aria-labelledby="aria-email aria-email-warn"
                ref={emailRef}
                className={formError.email ? 'is-invalid' : ''}
                onBlur={() => {
                  setValidateEmailOnChange(true);
                  validateFormFields();
                }}
                onChange={() => {
                  if (validateEmailOnChange) validateFormFields();
                  setRunMailCheck(true);
                }}
              />
              {formError.email && (
                <span className="errorMessage">{formError.email}</span>
              )}
              <div className="invalidEmailContainer">
                {showEmailConfirm && (
                  <div>
                    <Button
                      text={t('AccountDetails_MailCheck_ButtonYes')}
                      fill="outline"
                      className="mailCheckButton clickable-btn inactive-btn"
                      aria-label={t('Contact_EmailSuggestionYes').replace('xEmail', invalidEmailSuggestion)}
                      onClick={() => {
                        setRunMailCheck(false);
                        emailRef.current.value = invalidEmailSuggestion;
                        formError.email = null;
                        setInvalidEmailSuggestion(null);
                        setShowEmailConfirm(false);
                      }}
                    >
                      {t('Yes_Text')}
                    </Button>
                    <Button
                      text={t('AccountDetails_MailCheck_ButtonNo')}
                      fill="outline"
                      className="mailCheckButton clickable-btn inactive-btn"
                      aria-label={t('Contact_EmailSuggestionNo')}
                      onClick={() => {
                        setShowEmailConfirm(false);
                        setRunMailCheck(false);
                        formError.email = null;
                      }}
                    >
                      {t('No_Text')}
                    </Button>
                  </div>
                )}
              </div>
            </Form.Group>

            {/* Name */}
            <Form.Group
              className="form-groups"
              controlId="ContactForm_General_Name_"
              required
            >
              <Form.Label as="legend" id="name" className="form-labels">
                {t('ContactForm_Name')}
              </Form.Label>
              <Form.Control
                aria-labelledby="name"
                ref={nameRef}
                className={formError.name ? 'is-invalid' : ''}
                onBlur={() => {
                  setValidateNameOnChange(true);
                  validateFormFields();
                }}
                onChange={() => {
                  if (validateNameOnChange) validateFormFields();
                  setValidateNameOnChange(true);
                }}
              />
              {formError.name && (
                <span className="errorMessage">{formError.name}</span>
              )}
            </Form.Group>

            {/* Which payment option did you use */}
            <Form.Group
              className="form-inline form-groups"
              controlId="ContactForm_AppID_"
              required
            >
              <fieldset className="payments-radio">
                <Form.Label id="app_label" as="legend" className={`${formError.paymentMethod ? 'is-invalid' : ''} form-labels`}>
                  {t('ContactForm_Which_Payment_Option')}
                </Form.Label>
                <div className="radio-container">
                  <RadioBuilder
                    value="eTransfer"
                    group="webmobile"
                    selected={paymentMethod === 'eTransfer'}
                    clickHandler={() => {
                      setValidatePaymentMethodOnChange(true);
                      setPaymentMethod('eTransfer');
                    }}
                    content={(
                      <ReplaceTextWithElement
                        text={t('ContactForm_PaymentOption_eTransfer')}
                        replaceWith={<i>Interac</i>}
                        replaceKey="Interac"
                      />
                    )}
                  />
                  <RadioBuilder
                    value="Maple website"
                    group="webmobile"
                    selected={paymentMethod === 'In Person at Canada Post'}
                    clickHandler={() => {
                      setValidatePaymentMethodOnChange(true);
                      setPaymentMethod('In Person at Canada Post');
                    }}
                    content={(
                      <>
                        {t('In-Person_at_Canada_Post')}
                      </>
                    )}
                  />
                </div>
                {formError.paymentMethod && (
                  <span className="errorMessage errorMessageBlock">{formError.paymentMethod}</span>
                )}
              </fieldset>
            </Form.Group>

            {/* How can we help */}
            <Form.Group
              className="form-groups"
              controlId="ContactForm_General_Body_"
              required
            >
              <fieldset>
                <Form.Label as="legend" id="aria-desc" className="form-labels">
                  {t('ContactForm_General_Body_Label')}
                </Form.Label>

                <Form.Control
                  aria-labelledby="aria-desc"
                  as="textarea"
                  rows={8}
                  ref={bodyRef}
                  className={formError.description ? 'is-invalid' : ''}
                  onBlur={() => setValidateDescriptionOnChange(true)}
                  onChange={(e) => {
                    handleTextareaChange(e);
                    if (validateDescriptionOnChange) validateFormFields();
                  }}
                />
                {formError.description && (
                  <span className="errorMessage">{formError.description}</span>
                )}
              </fieldset>
            </Form.Group>
            <RelevantFAQ searchResults={searchResults} brand={brand} lang={lang} />
            <Button
              id="submit-button"
              className="paysimply-button"
              type="submit"
              disabled={disable}
              size="lg"
              style={{ backgroundColor: '#2B4E7B' }}
            >
              {t('ContactForm_Submit_button')}
            </Button>
          </Form>
          <Alert className="mt-3 email-banner" show={process.env.REACT_APP_ENV === 'dev'}>
            On the test system, contact form emails will be sent to
            <strong> psidevstar@gmail.com</strong>
          </Alert>
        </div>
      </div>
    </>
  );
}

export default translate(ContactUsPayments);
